import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import {type PaginatedResult, normalizePagination} from "@/utils/pagination";

export interface CommissionLedgerEntry {
  id: string;
  user_id: string;
  operation_id: string;
  operation_type: string;
  amount_cents: number;
  currency: string;
  description: string;
  created_at: string;
}

export interface CommissionLedgerSummary {
  total_cents: number;
  count: number;
  currency: string;
  by_operation_type: {
    operation_type: string;
    total_cents: number;
    count: number;
  }[];
}

interface CommissionLedgerFilters {
  operation_type?: string;
  currency?: string;
  limit?: number;
  offset?: number;
}

export type CommissionLedgerListResult = PaginatedResult<CommissionLedgerEntry>;

export const getCommissionLedgerService = async (
  filters: CommissionLedgerFilters = {}
): Promise<TResponseRequest<CommissionLedgerListResult>> => {
  const raw = await httpRequest.get<CommissionLedgerEntry[]>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/commission-ledger`, filters as Record<string, unknown>),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: {items: raw.data, pagination: normalizePagination(raw.pagination)}};
};

export const getCommissionLedgerSummaryService = async (
  currency?: string
): Promise<TResponseRequest<CommissionLedgerSummary>> => {
  const params: Record<string, unknown> = {};
  if (currency) params.currency = currency;
  return httpRequest.get<CommissionLedgerSummary>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/commission-ledger/summary`, params),
  });
};
